import { SovosBox, SovosPageContentGeneric } from "mosaic-react";
import React from "react";
import { PAGE_LAYOUT } from "./constants";

const ChooseEntityPageFrame = ({ children }) => (
    <SovosPageContentGeneric sx={{ px: { xs: 2, sm: 3 }, py: 3 }}>
        <SovosBox sx={{ mx: "auto", maxWidth: PAGE_LAYOUT.contentMaxWidth, width: "100%" }}>
            {children}
        </SovosBox>
    </SovosPageContentGeneric>
);

export default ChooseEntityPageFrame;
